import PrivacyPolicy from "../pages/public/PrivacyPolicy"
import TermsAndConditions from "../pages/public/TermsAndConditions"
export default [
    { path: '/software-license', exact: true, name: "Software License", component: TermsAndConditions },
    { path: '/privacy-policy', exact: true, name: "Privacy Policy", component: PrivacyPolicy },
]